export default "__VITE_ASSET__CVTbCe3P__"